module.exports = __webpack_public_path__ + "img/login.a9b08b2c.png";